import { orderBy, SortDescriptor } from '@progress/kendo-data-query'
import * as Modal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as References from '../reference'
import * as Constants from './constants'
import * as Types from './types'

const SOURCES_MODAL_ERROR_MESSAGE: string = `${Constants.NAME} and ${Constants.SOURCE_IDENTIFIER} are required fields`

export const sortSources = (sources: Types.Source[], sort: SortDescriptor[]): Types.Source[] => {
  return orderBy(sources, sort)
}

export const addSourceModalStateValid = (state: Types.AddSourceData): boolean => {
  return state.name !== '' && state.identifier !== ''
}

export const sourceImportValidator: Modal.CsvFileValidator = (headers: string[]): RasaInput.Validation => {
  const acceptableHeaders = headers.map((value: string) => value.toLowerCase().replace(' ', '_'))
  if ( acceptableHeaders.includes(Constants.NAME) &&
       ( acceptableHeaders.includes(Constants.SOURCE_IDENTIFIER) ||
         acceptableHeaders.includes('source_identifier') ||
         acceptableHeaders.includes('sourceidentifier') ||
         acceptableHeaders.includes('include_filtergroups') ||
         acceptableHeaders.includes('exclude_filtergroups') ||
         acceptableHeaders.includes('include_matches') ||
         acceptableHeaders.includes('exclude_matches')
       )
     ) {
    return RasaInput.validValidation
  } else {
    return { invalid: true, message: SOURCES_MODAL_ERROR_MESSAGE }
  }
}

export const importModalStateValid = (state: Types.ImportSourceData): boolean => state.isValid

export const addModalStateValid = (state: Types.AddSourceData): boolean =>
  !RasaInput.validateTitle(state.name).invalid && !validateIdentifier(state).invalid

export const validateIdentifier = (state: Types.AddSourceData): RasaInput.Validation => {
  if (state.source_type === References.TWITTER_FEED) {
    return state.identifier === '' ?
        RasaInput.missingValidation
      : /^[0-9a-z_]+$/i.test(state.identifier) ?
        RasaInput.validValidation
      : {
          invalid: true,
          message: 'Only Alpha-numeric and underscore (_) are allowed',
          status: RasaInput.VALIDATION_FORMAT,
        }

  } else {
    return RasaInput.validateUrl(state.identifier)
  }
}

export const sourceUrl = (source: Types.Source): string => {
  switch (source.source_type) {
    case References.TWITTER_FEED:
      return 'https://www.twitter.com/' + source.source_url
    case References.MANUAL_ENTRY_FEED:
      return null
    default:
      return source.source_url
  }
}

export const byCategory = (sources: Types.SourcesDataState, category: References.ReferenceData): Types.Source[] => {
  return sources.filter((s: Types.Source) => s.category_type === category.name)
}



// WEBPACK FOOTER //
// ./src/pages/sources/utils.ts